import { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { getDeeplinks, signin } from "../services/api"
import { decrypt } from "../services/decryption"

let encryptionKey = process.env.NODE_ENV==="development" ? process.env.REACT_APP_LOCAL_ENCRYPTION_KEY : process.env.REACT_APP_REMOTE_ENCRYPTION_KEY

let creds = {
    username: process.env.REACT_APP_USERNAME,
    password: process.env.REACT_APP_PASSWORD
}

creds = { encryptedData: decrypt(JSON.stringify(creds), encryptionKey)}

const Deeplink = () => {

    const { landmarkId } = useParams()

    const [searchParams, setSearchParams] = useSearchParams()
    let destination = searchParams.get("destination")

    const fetchData = async () => {
        let userResponse = await signin(creds, true)
        localStorage.setItem("accessToken", userResponse?.data?.accessToken)
        localStorage.setItem("refreshToken", userResponse?.data?.refreshToken)
        let response = await getDeeplinks(landmarkId)
        const { appId, appStoreId, deeplinkUrl } = response?.data
        window.location.assign(`iwayplus://${deeplinkUrl}/landmark?source=${landmarkId}&destination=${destination}`)

        let appTimeout = setTimeout(() => {

            if(navigator.platform.includes("iPhone") || navigator.platform.includes("Mac")) window.location.assign(`https://apps.apple.com/in/app/${appStoreId}`)
            else window.location.assign(`https://play.google.com/store/apps/details?id=${appId}`)

        }, 3000)

        return appTimeout

    }

    useEffect(() => {
        let timeout = fetchData()

        return () => clearTimeout(timeout)
    }, [])
    return (
        <></>
    )
}

export default Deeplink

// https://apps.apple.com/in/app/rni-navigation/id6738083189